import { CircularProgress, Grid } from "@mui/material";
import { Box } from "@mui/system";
import { Formik } from "formik";
import React, { useState } from "react";
import { useStyles } from "../../assets/styles/BloodSugarStyles";
import { StyledButton, StyledCrossIcon, StyledFormik } from "../../assets/styles/CommonStyles";
import { capitalizeFirstLetter } from "../../constant/staticHelper";
import { spo2Scale } from "../../constant/staticLists";
import strings from "../../constant/strings";
import { bloodOxygenSchema } from "../../utils/forms/schema.bloodOxygenSchema";
import FieldWrapper from "../InputField/TextFieldWrapper";
import * as mainService from "../../services/mainService.js";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import SelectionDropdown from "../control/SelectionDropdown";

const BloodOxygen = ({ setOpenModal, getUpdatedValue }) => {
  const classes = useStyles();
  let initialValues= {
    spo2Percentage: "",
    note: "",
    readingMethod: ""
  }
  const oxygenLevel = Object.keys(spo2Scale).map(key => ({
    label: capitalizeFirstLetter(key.replace(/_/g, ' ').toLowerCase()),
    level: spo2Scale[key]
  }));
  const [buttonLoading, setButtonLoading] = useState(false);
  const { userData } = useSelector((state) => ({
    userData: state.auth.userData
  }));

  const handleSubmit = async (values, { resetForm }) => {
    const data = {
      percentage: values.spo2Percentage,
      reading_method: values.readingMethod,
      notes: values.note,
      token: userData.token
    }
    const res = await mainService.addBloodOxygenApi(data);
    if (res.response_type === "fail") {
      setButtonLoading(false);
      toast.error(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    } else {
      resetForm();
      setButtonLoading(false);
      getUpdatedValue(true);
      setOpenModal(false);
      toast.success(res?.response?.message, { position: "bottom-center", closeButton: false, autoClose: 2000, style: {width: 'auto', borderRadius: 8 }});
    }
  }

  return (
    <div>
      <Grid className={classes.secondayCont}>
        <h2 className={classes.mainCont}>{strings.bloodOxygen}</h2>
        <StyledCrossIcon
          src={"/assets/img/x.png"}
          alt="User"
          onClick={() => setOpenModal(false)}
        />

      </Grid>
      <div>
        <Formik
          initialValues={initialValues}
          validationSchema={bloodOxygenSchema}
          onSubmit={handleSubmit}
        >
          {({
            handleChange,
            errors,
            handleSubmit, setFieldValue, validateField
          }) => {
            const handleDropdownValue = (data) => {
              if (data) {
                const ids = data.level;
                setFieldValue("readingMethod", ids);
              } else {
                setFieldValue("readingMethod", '');
              }
              validateField("readingMethod");
            }
            return (
            <StyledFormik>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FieldWrapper
                    name="spo2Percentage"
                    label={`${strings.spo2Per}`}
                    type="number"
                    onChange={(e) => {
                      handleChange("spo2Percentage")(e);
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <SelectionDropdown
                    name= "readingMethod"
                    label={`${strings.readingType}`}
                    handleDropdownValue={handleDropdownValue}
                    list={oxygenLevel}
                  />
                </Grid>
                <Grid item xs={12}>
                  <FieldWrapper
                    name="note"
                    type="text"
                    label={`${strings.note}`}
                    onChange={(e) => {
                      handleChange("note")(e);
                    }}
                  />
                </Grid>
              </Grid>
              <Box m={1} pt={1}>
                <StyledButton
                  name="submit"
                  disabled={Object.keys(errors).length > 0 || buttonLoading}
                  onClick={handleSubmit}
                  variant="contained">
                  {buttonLoading ? (
                    <CircularProgress
                      style={{ color: "white" }}
                      size={20}
                      thickness={5}
                    />
                  ) : `${strings.save}`}

                </StyledButton>
              </Box>
            </StyledFormik>
          )}}
        </Formik>
      </div>
    </div>
  )
}

export default BloodOxygen;